export default {
    // Currently used
    home_search_for_product: "Suchen Sie nach Ihrem Produkt",
    conventional_alternative: "Konventionelle Alternative",
    led_alternative: "LED-Alternative",
    search_filters_filter: "Filter",
    search_submit: "Suche",
    results: "Ergebnisse",
    selected_product: "Ausgewähltes Produkt",
    search_input: "Geben Sie (einen Teil) des Produktcodes oder der Beschreibung ein",
    what_type_are_you_looking_for: "Suchen Sie eine konventionelle oder LED-Alternative?",
    recommendations_singular: "Empfehlungen",
    recommendations_plural: "Empfehlungen",
    your_product: "Ihr Produkt",
    search_filters_reset: "Filter zurücksetzen",
    results_specify: "Es gibt mehr als 10 Ergebnisse, bitte spezifizieren Sie Ihre Suche genauer",
    energy_efficient: "Energieffizienz",
    active_filters: "Aktive Filter",
    card_action: "Katalog",
    card_show_more: "Mehr anzeigen",
    card_show_less: "Weniger anzeigen",
    card_alternative_fit: "Beste Alternative von Philips",
    card_perfect_fit: "Beste Bassform von Philips",
    no_results_found: "Keine Ergebnisse gefunden. Bitte versuchen Sie eine andere Suchanfrage",
    results_no_recommendations: "Sie kommen nicht weiter? Bitte wenden Sie sich an Ihren Kundenbetreuer oder Vertriebsmitarbeiter vor Ort, um eine Lösung zu finden.",
    ballast_notice: "Bitte prüfen Sie die Kompatibiltät des elektronischen Vorschaltgerätes",
    ballast_notice_tled_link_text: "Kompatibilitätsliste TLED",
    ballast_notice_pl_led_link_text: "Kompatibilitätsliste PLED",
    alt_filters_filter: "Filter der LED Alternative",
    led_no_recommendations: "Es gibt aktuell keine LED Alternative für dieses Produkt",

    // LED facets
    search_filter_product_type: "Produkttype",
    lighting_type: "Lampentype",
    ean: "EAN",
    product_code: "Produktcode",
    eoc: "EOC",
    family: "Familie",
    discrete_wattage: "Leistung",
    wattage: "Leistung",
    brand: "Marke",
    driver_type: "Art des Vorschaltgerätes",
    number_of_lamps: "Anzahl Lampen",
    length: "Länge",
    color: "Farbe",
    base: "Sockel",
    lumen: "Lichtstrom",
    local_eoc: "Bestellnummer",
    energy_saving: "Energieeinsparung",
    ballast_compatibility: "Kompatibilität mit Vorschaltgerät",
    tiering: "Produktlevel",
    lifetime: "Nutzlebensdauer",

    // Conventional facets
    ignitor: "Zündgerät",
    height: "Höhe",
    width: "Breite",
    mounting_hole: "Lochabstand",
    mains_voltage: "230V",
    thermal_protection: "Temperaturschutz",
    delta_temperature: "Temperaturdifferenz",
    energy_efficiency: "Energieeffizienz",
    losses: "Verlustleistung",
    lamp_current: "Lampenstrom",
    pf_cap: "Leistungsfaktor (C)",
};
